import React from 'react';
import { cn } from '../../../../../utils/styles';

interface SearchItemProps extends React.PropsWithChildren {
  variant?: 'regular' | 'title';
  counter?: number;
  onClick?: () => void;
}

function SearchItem({ variant, counter, onClick, children }: SearchItemProps) {
  return (
    <div
      className={cn(['flex items-center justify-between gap-2', 'py-1 px-2 bg-slate-200 text-sm rounded'], {
        'bg-slate-300 font-medium': variant === 'title',
        'cursor-default': !onClick,
      })}
      role="button"
      tabIndex={-1}
      onClick={onClick}
    >
      <div>{children}</div>
      {counter ? <div>{`(${counter})`}</div> : null}
    </div>
  );
}

SearchItem.defaultProps = {
  variant: 'regular',
  counter: undefined,
  onClick: undefined,
};

export default SearchItem;
